
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35182',
  depVersions: {
  "documents-public-ui": "static-1.35182",
  "atom": "static-1.5363",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2766",
  "client-types": "static-1.496",
  "cssUtils": "static-1.897",
  "customer-data-filters-ui": "static-1.40850",
  "customer-data-objects": "static-1.7968",
  "customer-data-property-utils": "static-1.8379",
  "documents-lib": "static-1.35187",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.365",
  "FormsCommonComponents": "static-1.86518",
  "FormUrlGenerator": "static-2.5005",
  "foundations-theming-specialty": "static-1.2465",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5874",
  "hs-test-utils": "static-1.8310",
  "hub-http": "static-1.6490",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12071",
  "HubStyleTokens": "static-2.11764",
  "I18n": "static-7.1668",
  "icons": "static-2.677",
  "jasmine-immutable": "static-1.3298",
  "jasmine-runner": "static-1.6730",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7428",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3172",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5675",
  "quartz": "static-1.7427",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16995",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5540",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8459",
  "reference-resolvers-lite": "static-1.8379",
  "reporting-data": "static-1.68747",
  "reporting-reports": "static-1.68424",
  "reporting-snowflake": "static-1.57364",
  "reporting-testing-lib": "static-1.10680",
  "reporting-visualizations": "static-1.60822",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9229",
  "sanitize": "static-1.4751",
  "sanitize-text": "static-1.8431",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2024",
  "signup-constants": "static-1.19581",
  "signup-ui-url-generator": "static-2.8339",
  "StyleGuideUI": "static-3.500",
  "superstore": "static-1.5034",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5036",
  "ui-addon-form-validation": "static-1.11260",
  "ui-asset-management-lib": "static-1.11375",
  "ui-images": "static-2.1238",
  "UIComponents": "static-3.8710",
  "usage-tracker": "static-1.7633",
  "usage-tracker-container": "static-1.7623",
  "usage-tracker-core": "static-1.7483",
  "viral-links-lib": "static-1.7353",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9934",
  "foundations-components": "static-1-ech-accordiontransition-jank.29",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1205",
  "quartz-core": "static-1.6646",
  "quick-fetch": "static-1.4115",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4943",
  "ui-addon-i18n": "static-1.11423",
  "ui-addon-upgrades": "static-9.18352",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3603",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3704",
  "quartz-webpack": "static-1.3651",
  "foundations-assets": "static-1.5161",
  "foundations-theming": "static-1.4749",
  "hub-http-janus": "static-1.874",
  "hub-http-shared-msw-handlers": "static-1.10579",
  "hubspotter-http": "static-1.4848",
  "sassPrefix": "static-1.170",
  "conversations-skeleton-state": "static-1.7523",
  "crm-message-bus": "static-1.43711",
  "customer-data-filters-ui-msw-helpers": "static-1.23285",
  "customer-data-objects-ui-components": "static-1.13308",
  "customer-data-reference-ui-components": "static-1.13456",
  "customer-data-ui-utilities": "static-1.10106",
  "events-data-lib": "static-1.520",
  "framework-builder-read-service-client": "static-1.4205",
  "hs-resources": "static-1.470",
  "immer": "static-1.96",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4040",
  "multi-account-reference-resolvers": "static-1.1279",
  "onboarding-scopes": "static-1.6731",
  "onboarding-tours": "static-1.17084",
  "pulse": "static-1.906",
  "reporting-datasets-permissions-lib": "static-1.14424",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2576",
  "trellis-components": "static-1.2595",
  "trellis-theming": "static-1.1249",
  "ui-addon-teams": "static-1.21884",
  "quartz-auth": "static-1.1102",
  "ui-business-units-lib": "static-1.9364",
  "usage-tracker-session-replay": "static-1.5319",
  "ai-components-ui-library": "static-1.9667",
  "ContentUtils": "static-1.69081",
  "customer-data-properties": "static-1.52514",
  "forms-ai-lib": "static-1.4733",
  "forms-utils-lib": "static-1.13064",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.29",
  "react-dnd-compat": "static-1.4894",
  "react-tinymce": "static-1.55934",
  "tinymce-config": "static-2.55060",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3734",
  "HeadJS": "static-2.793",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3421",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.277",
  "ui-fonts": "static-1.1026",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4591",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1092",
  "web-vitals": "static-1.12",
  "batch-promise": "static-1.1821",
  "external-options-client-types": "static-1.4323",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7169",
  "quartz-i18n": "static-1.1102",
  "frontend-preferences-client": "static-1.8200",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3978",
  "reporting-client-types": "static-1.2669",
  "apollo-stack-hubspot": "static-3.91",
  "growth-payments-core": "static-1.26135",
  "hubspot-apollo-client": "static-1.5156",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.29",
  "quartz-routing": "static-1.857",
  "hs-story-utils": "static-1.9703",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.511",
  "seat-types-lib": "static-1.673",
  "timezone-utils": "static-2.5522",
  "react-create-root-preference": "static-1.67",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.29",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.47",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.574",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.422",
  "quartz-test": "static-1.1102",
  "quartz-tracking": "static-1.806",
  "bend-plugin-chirp-manifest": "static-1.353",
  "chirp-fetch": "static-1.2172",
  "merchandise-lib": "static-1.276",
  "purchase-motions-components": "static-1.6329",
  "salesImages": "static-1.541",
  "ts-schema": "static-1.4277",
  "bender-build-tools": "static-1.3425",
  "bend-plugin-foundations-theming": "static-1.3232",
  "restore-request-side-panel-lib": "static-1.1626",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4933",
  "conditional-properties-service-client": "static-1.3996",
  "crm-pipelines-api-client-types": "static-1.4331",
  "event-emitter": "static-1.1230",
  "fdsr-migration-layer": "static-1.288",
  "multi-currency-client-types": "static-1.3892",
  "getting-started-shared-tasks": "static-1.19191",
  "growth-data-modal": "static-1.5862",
  "growth-onboarding-confetti": "static-1.3339",
  "growth-onboarding-next-action-utils": "static-1.2646",
  "navigation-components": "static-1.18782",
  "onboarding-tours-client": "static-1.5299",
  "onboarding-tours-utils": "static-1.1151",
  "ui-shepherd-react": "static-3.10546",
  "ui-shepherd-tracker": "static-1.7927",
  "ui-universal-auth": "static-1.9356",
  "user-context": "static-1.5396",
  "bend-plugin-pulse": "static-1.409",
  "fast-json-patch": "static-1.67",
  "stylex-utils": "static-1.137",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10577",
  "magpie-lib": "static-1.5738",
  "navigation-messaging": "static-1.8109",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22869",
  "copilot-toolkit": "static-1.11812",
  "cms-field-types": "static-1.5092",
  "content-icons-ui": "static-1.2341",
  "integrations-lib": "static-1.16986",
  "calling-global-api": "static-1.65528",
  "calling-internal-common": "static-1.31595",
  "calling-lifecycle-internal": "static-1.66910",
  "calling-lifecycle-messages": "static-1.59204",
  "commerce-products-lib": "static-1.10484",
  "crm-index-visualization-core": "static-1.4514",
  "crm-links": "static-1.6607",
  "customer-data-properties-shared-msw-handlers": "static-1.9906",
  "file-manager-components": "static-1.24436",
  "formula-editor": "static-1.14720",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4410",
  "meetings-icalendar-utils-lib": "static-1.913",
  "object-builder-ui-client": "static-1.49618",
  "pipeline-validation-client-types": "static-1.4165",
  "property-value-citations": "static-1.3128",
  "smart-data-capture-core": "static-1.96",
  "smart-property-lib": "static-1.8241",
  "tiered-pricing": "static-1.1919",
  "topics-actions-lib": "static-1.442",
  "trial-components-library": "static-1.14072",
  "ui-addon-iframeable": "static-1.9354",
  "zustand": "static-1.82",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20275",
  "tinymce-themes": "static-1.57030",
  "data-token-picker": "static-1.16856",
  "hub-http-contrib": "static-1.3316",
  "interframe": "static-3.5032",
  "tinymce-data": "static-1.41145",
  "tinymce-plugins": "static-1.58174",
  "ui-addon-sales-email": "static-1.5490",
  "framework-data-schema-quick-fetch": "static-1.7074",
  "ui-addon-opt": "static-4.8641",
  "hubspot-apollo-cache": "static-1.615",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.426",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6332",
  "onboarding-data-sync-lib": "static-1.2473",
  "growth-onboarding-next-action-components": "static-1.2674",
  "user-context-client": "static-1.4786",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5198",
  "nest": "static-1.513",
  "reactive-lib": "static-1.997",
  "simple-logging-lib": "static-1.3328",
  "unified-auth-core-lib": "static-1.1152",
  "getting-started-shared-tasks-store": "static-1.18309",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1661",
  "integrations-error-boundary-lib": "static-1.14401",
  "integrations-tracking-lib": "static-1.5886",
  "native-integrations-shared-strings": "static-1.8056",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10647",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.870",
  "calling-error-reporting": "static-1.31602",
  "shared-worker-versioning": "static-1.11318",
  "calling-usage-tracker": "static-1.6814",
  "voice-sms-access-library": "static-1.1980",
  "customer-data-tracking": "static-1.7159",
  "commerce-permissions": "static-1.1055",
  "products-iframe-lib": "static-1.8548",
  "products-ui-components-shared-msw-handlers": "static-1.10961",
  "crm-index-associations-lib": "static-1.6719",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10662",
  "sales-views-client-types": "static-1.4533",
  "location-customization-utils-lib": "static-1.10055",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4427",
  "video-components-external": "static-1.12112",
  "video-data-lib": "static-1.35770",
  "bark-lib": "static-1.16789",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6167",
  "react-codemirror": "static-1.10917",
  "data-agent-kit": "static-1.617",
  "feedback-loader": "static-1.29777",
  "fsm": "static-1.4026",
  "policy-lib": "static-1.7077",
  "react-colorpicker": "static-2.10485",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10725",
  "embedded-academy-lib": "static-1.15469",
  "hubs-service-types": "static-1.1535",
  "FileManagerLib": "static-1.40076",
  "NamespacedHubStyle": "static-2.9247",
  "FileManagerCore": "static-1.39935",
  "content-assistance-lib": "static-1.8169",
  "layout-dnd-components": "static-1.12934",
  "layout-dnd-utils": "static-1.11909",
  "ui-addon-emoji-picker": "static-1.10163",
  "ui-brand-identity-lib": "static-1.16393",
  "InboxConnectUtils": "static-4.15516",
  "meetings-connect-utils-lib": "static-1.7885",
  "breeze-engine-chat-components": "static-1.639",
  "breeze-engine-core": "static-1.939",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3285",
  "adobe-sign-auth-lib": "static-1.418",
  "ads-unified-auth-lib": "static-1.1230",
  "google-sheets-integration-lib": "static-1.987",
  "microsoft-drive-auth-lib": "static-1.88",
  "surveymonkey-integration-lib": "static-1.429",
  "slack-ui-library": "static-1.10676",
  "calling-orchestration-schema": "static-1.36757",
  "crm-record-cards-service-types": "static-1.3770",
  "content-media-composition-data-lib": "static-1.13193",
  "content-media-compositions": "static-2.17200",
  "media-bridge-lib": "static-1.19376",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16323",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4786",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14929",
  "audio-components": "static-1.6311",
  "FileManagerImages": "static-1.37587",
  "video-components": "static-1.14114",
  "breeze-artifacts-sdk": "static-1.264",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4810",
  "video-embed": "static-1.36604",
  "ui-addon-video-player": "static-1.8980",
  "ui-coaching-tips": "static-1.29264",
  "ContentData": "static-1.69156",
  "layout-data-lib": "static-1.10234",
  "academy-service-client": "static-1.3965",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4680",
  "trellis-ecosystem": "static-1.7597",
  "ui-addon-react-router-dom": "static-1.9815",
  "wootric-nps": "static-1.7184",
  "social-insights-client-types": "static-1.22692",
  "outpost": "static-1.4435",
  "growth-onboarding-feedback-components": "static-1.6861",
  "advanced-menus-core": "static-1.15546",
  "advanced-menus-lib": "static-1.12423",
  "ExportDialog": "static-6.10656",
  "ui-memberships-settings-lib": "static-1.34797",
  "marketplace-ui-apps-core": "static-1.19204",
  "marketplace-ui-common": "static-1.20672",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15545",
  "simple-menus-lib": "static-1.17062",
  "developer-experience-shared-components": "static-1.10781",
  "immutable-less": "static-1.4927",
  "marketplace-ui-client-types": "static-1.18079",
  "ui-addon-integrations-directory-panel": "static-2.8302",
  "ui-extensibility-client-types": "static-1.4195",
  "ai-settings-ui-library": "static-1.8292",
  "nav-meta": "static-1.30419",
  "ui-product-approvals-common": "static-1.977",
  "apps-service-types": "static-1.4017",
  "oauth-service-types": "static-1.4514",
  "simple-data-table": "static-1.3493"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35182",
  "atom": "/atom/static-1.5363",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2766",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.897",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40850",
  "customer-data-objects": "/customer-data-objects/static-1.7968",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8379",
  "documents-lib": "/documents-lib/static-1.35187",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.365",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86518",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5005",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2465",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5874",
  "hs-test-utils": "/hs-test-utils/static-1.8310",
  "hub-http": "/hub-http/static-1.6490",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12071",
  "HubStyleTokens": "/HubStyleTokens/static-2.11764",
  "I18n": "/I18n/static-7.1668",
  "icons": "/icons/static-2.677",
  "jasmine-immutable": "/jasmine-immutable/static-1.3298",
  "jasmine-runner": "/jasmine-runner/static-1.6730",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7428",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3172",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5675",
  "quartz": "/quartz/static-1.7427",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16995",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5540",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8459",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8379",
  "reporting-data": "/reporting-data/static-1.68747",
  "reporting-reports": "/reporting-reports/static-1.68424",
  "reporting-snowflake": "/reporting-snowflake/static-1.57364",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10680",
  "reporting-visualizations": "/reporting-visualizations/static-1.60822",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9229",
  "sanitize": "/sanitize/static-1.4751",
  "sanitize-text": "/sanitize-text/static-1.8431",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2024",
  "signup-constants": "/signup-constants/static-1.19581",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8339",
  "StyleGuideUI": "/StyleGuideUI/static-3.500",
  "superstore": "/superstore/static-1.5034",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5036",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11260",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11375",
  "ui-images": "/ui-images/static-2.1238",
  "UIComponents": "/UIComponents/static-3.8710",
  "usage-tracker": "/usage-tracker/static-1.7633",
  "usage-tracker-container": "/usage-tracker-container/static-1.7623",
  "usage-tracker-core": "/usage-tracker-core/static-1.7483",
  "viral-links-lib": "/viral-links-lib/static-1.7353",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9934",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.29",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1205",
  "quartz-core": "/quartz-core/static-1.6646",
  "quick-fetch": "/quick-fetch/static-1.4115",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4943",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11423",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18352",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3603",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3704",
  "quartz-webpack": "/quartz-webpack/static-1.3651",
  "foundations-assets": "/foundations-assets/static-1.5161",
  "foundations-theming": "/foundations-theming/static-1.4749",
  "hub-http-janus": "/hub-http-janus/static-1.874",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10579",
  "hubspotter-http": "/hubspotter-http/static-1.4848",
  "sassPrefix": "/sassPrefix/static-1.170",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7523",
  "crm-message-bus": "/crm-message-bus/static-1.43711",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23285",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13308",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13456",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10106",
  "events-data-lib": "/events-data-lib/static-1.520",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4205",
  "hs-resources": "/hs-resources/static-1.470",
  "immer": "/immer/static-1.96",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4040",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1279",
  "onboarding-scopes": "/onboarding-scopes/static-1.6731",
  "onboarding-tours": "/onboarding-tours/static-1.17084",
  "pulse": "/pulse/static-1.906",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14424",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2576",
  "trellis-components": "/trellis-components/static-1.2595",
  "trellis-theming": "/trellis-theming/static-1.1249",
  "ui-addon-teams": "/ui-addon-teams/static-1.21884",
  "quartz-auth": "/quartz-auth/static-1.1102",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9364",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5319",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9667",
  "ContentUtils": "/ContentUtils/static-1.69081",
  "customer-data-properties": "/customer-data-properties/static-1.52514",
  "forms-ai-lib": "/forms-ai-lib/static-1.4733",
  "forms-utils-lib": "/forms-utils-lib/static-1.13064",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.29",
  "react-dnd-compat": "/react-dnd-compat/static-1.4894",
  "react-tinymce": "/react-tinymce/static-1.55934",
  "tinymce-config": "/tinymce-config/static-2.55060",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3734",
  "HeadJS": "/HeadJS/static-2.793",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3421",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.277",
  "ui-fonts": "/ui-fonts/static-1.1026",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4591",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1092",
  "web-vitals": "/web-vitals/static-1.12",
  "batch-promise": "/batch-promise/static-1.1821",
  "external-options-client-types": "/external-options-client-types/static-1.4323",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7169",
  "quartz-i18n": "/quartz-i18n/static-1.1102",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8200",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3978",
  "reporting-client-types": "/reporting-client-types/static-1.2669",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
  "growth-payments-core": "/growth-payments-core/static-1.26135",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5156",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.29",
  "quartz-routing": "/quartz-routing/static-1.857",
  "hs-story-utils": "/hs-story-utils/static-1.9703",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.511",
  "seat-types-lib": "/seat-types-lib/static-1.673",
  "timezone-utils": "/timezone-utils/static-2.5522",
  "react-create-root-preference": "/react-create-root-preference/static-1.67",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.29",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.47",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.574",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.422",
  "quartz-test": "/quartz-test/static-1.1102",
  "quartz-tracking": "/quartz-tracking/static-1.806",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.353",
  "chirp-fetch": "/chirp-fetch/static-1.2172",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "purchase-motions-components": "/purchase-motions-components/static-1.6329",
  "salesImages": "/salesImages/static-1.541",
  "ts-schema": "/ts-schema/static-1.4277",
  "bender-build-tools": "/bender-build-tools/static-1.3425",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3232",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1626",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4933",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3996",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4331",
  "event-emitter": "/event-emitter/static-1.1230",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.288",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3892",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19191",
  "growth-data-modal": "/growth-data-modal/static-1.5862",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3339",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2646",
  "navigation-components": "/navigation-components/static-1.18782",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5299",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1151",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10546",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7927",
  "ui-universal-auth": "/ui-universal-auth/static-1.9356",
  "user-context": "/user-context/static-1.5396",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.409",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "stylex-utils": "/stylex-utils/static-1.137",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10577",
  "magpie-lib": "/magpie-lib/static-1.5738",
  "navigation-messaging": "/navigation-messaging/static-1.8109",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22869",
  "copilot-toolkit": "/copilot-toolkit/static-1.11812",
  "cms-field-types": "/cms-field-types/static-1.5092",
  "content-icons-ui": "/content-icons-ui/static-1.2341",
  "integrations-lib": "/integrations-lib/static-1.16986",
  "calling-global-api": "/calling-global-api/static-1.65528",
  "calling-internal-common": "/calling-internal-common/static-1.31595",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66910",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59204",
  "commerce-products-lib": "/commerce-products-lib/static-1.10484",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4514",
  "crm-links": "/crm-links/static-1.6607",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9906",
  "file-manager-components": "/file-manager-components/static-1.24436",
  "formula-editor": "/formula-editor/static-1.14720",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4410",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.913",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49618",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4165",
  "property-value-citations": "/property-value-citations/static-1.3128",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.96",
  "smart-property-lib": "/smart-property-lib/static-1.8241",
  "tiered-pricing": "/tiered-pricing/static-1.1919",
  "topics-actions-lib": "/topics-actions-lib/static-1.442",
  "trial-components-library": "/trial-components-library/static-1.14072",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9354",
  "zustand": "/zustand/static-1.82",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20275",
  "tinymce-themes": "/tinymce-themes/static-1.57030",
  "data-token-picker": "/data-token-picker/static-1.16856",
  "hub-http-contrib": "/hub-http-contrib/static-1.3316",
  "interframe": "/interframe/static-3.5032",
  "tinymce-data": "/tinymce-data/static-1.41145",
  "tinymce-plugins": "/tinymce-plugins/static-1.58174",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5490",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7074",
  "ui-addon-opt": "/ui-addon-opt/static-4.8641",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.615",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6332",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2473",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2674",
  "user-context-client": "/user-context-client/static-1.4786",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5198",
  "nest": "/nest/static-1.513",
  "reactive-lib": "/reactive-lib/static-1.997",
  "simple-logging-lib": "/simple-logging-lib/static-1.3328",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1152",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18309",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1661",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14401",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5886",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8056",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10647",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.870",
  "calling-error-reporting": "/calling-error-reporting/static-1.31602",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11318",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6814",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1980",
  "customer-data-tracking": "/customer-data-tracking/static-1.7159",
  "commerce-permissions": "/commerce-permissions/static-1.1055",
  "products-iframe-lib": "/products-iframe-lib/static-1.8548",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10961",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6719",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10662",
  "sales-views-client-types": "/sales-views-client-types/static-1.4533",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10055",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4427",
  "video-components-external": "/video-components-external/static-1.12112",
  "video-data-lib": "/video-data-lib/static-1.35770",
  "bark-lib": "/bark-lib/static-1.16789",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6167",
  "react-codemirror": "/react-codemirror/static-1.10917",
  "data-agent-kit": "/data-agent-kit/static-1.617",
  "feedback-loader": "/feedback-loader/static-1.29777",
  "fsm": "/fsm/static-1.4026",
  "policy-lib": "/policy-lib/static-1.7077",
  "react-colorpicker": "/react-colorpicker/static-2.10485",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10725",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15469",
  "hubs-service-types": "/hubs-service-types/static-1.1535",
  "FileManagerLib": "/FileManagerLib/static-1.40076",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9247",
  "FileManagerCore": "/FileManagerCore/static-1.39935",
  "content-assistance-lib": "/content-assistance-lib/static-1.8169",
  "layout-dnd-components": "/layout-dnd-components/static-1.12934",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11909",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10163",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16393",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15516",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7885",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.639",
  "breeze-engine-core": "/breeze-engine-core/static-1.939",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3285",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.418",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1230",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.987",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.88",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.429",
  "slack-ui-library": "/slack-ui-library/static-1.10676",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36757",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3770",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13193",
  "content-media-compositions": "/content-media-compositions/static-2.17200",
  "media-bridge-lib": "/media-bridge-lib/static-1.19376",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16323",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4786",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14929",
  "audio-components": "/audio-components/static-1.6311",
  "FileManagerImages": "/FileManagerImages/static-1.37587",
  "video-components": "/video-components/static-1.14114",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.264",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4810",
  "video-embed": "/video-embed/static-1.36604",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8980",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29264",
  "ContentData": "/ContentData/static-1.69156",
  "layout-data-lib": "/layout-data-lib/static-1.10234",
  "academy-service-client": "/academy-service-client/static-1.3965",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4680",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7597",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9815",
  "wootric-nps": "/wootric-nps/static-1.7184",
  "social-insights-client-types": "/social-insights-client-types/static-1.22692",
  "outpost": "/outpost/static-1.4435",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6861",
  "advanced-menus-core": "/advanced-menus-core/static-1.15546",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12423",
  "ExportDialog": "/ExportDialog/static-6.10656",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34797",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19204",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20672",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15545",
  "simple-menus-lib": "/simple-menus-lib/static-1.17062",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10781",
  "immutable-less": "/immutable-less/static-1.4927",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18079",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8302",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4195",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8292",
  "nav-meta": "/nav-meta/static-1.30419",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.977",
  "apps-service-types": "/apps-service-types/static-1.4017",
  "oauth-service-types": "/oauth-service-types/static-1.4514",
  "simple-data-table": "/simple-data-table/static-1.3493"
}
};
